export function Sidebar() {
	return (
		<div className="hidden md:flex flex-col bg-light dark:bg-dark rounded-2xl drop-shadow-2xl col-span-1 p-6 gap-4 overflow-y-auto overflow-x-hidden">
			<img src="/public/cherry-blossom.png?size=180" />
			<div className="flex flex-col">
				<h4 className="text-3xl lg:text-4xl font-fancy text-center">MARCH</h4>
				<h4 className="text-5xl lg:text-6xl font-fancy text-center"><strong>6</strong><sup className="text-sm italic align-[2em]">th</sup></h4>
				<h4 className="text-3xl lg:text-4xl font-fancy text-center">2027</h4>
			</div>
		</div>
	);
}

export default Sidebar;
